<template>
  <div>
    <v-dialog v-model="showAlertError" persistent width="500">
      <v-card>
        <v-card-title class="headline red accent-4" primary-title>
          {{ $t('ordenesCompras.error') }}
        </v-card-title>
        <v-card-text>
          {{ mensajeError }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="cerrarShowAlertError()">
            {{ $t('ordenesCompras.aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert
      v-if="observaciones.length > 0"
      outlined
      :color="colorAlertObervaciones"
      border="left"
      icon="mdi-bell-ring"
    >
      {{ $t('ordenesCompras.ustedTiene') }}
      <strong>{{ observaciones.length }}</strong>
      {{ $t('ordenesCompras.comprasConObservaciones') }}
    </v-alert>

    <h3>
      {{ $t('ordenesCompras.listaOrdenesDeCompra') }}
      <span v-if="!noHayOrdenesCompras">
        {{ `(${ordenesCompras.length})` }}
      </span>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            text
            v-on="on"
            @click="descargarOrdenesComprasExcel()"
          >
            <v-icon>mdi-cloud-download</v-icon>
            <span class="hidden-sm-and-down ml-2">{{
              $t('ordenesCompras.excel')
            }}</span>
          </v-btn>
        </template>
        <span>{{ $t('ordenesCompras.descargarExcel') }}</span>
      </v-tooltip>
    </h3>

    <v-container grid-list-md text-xs-center>
      <v-row class="pb-0 mb-0">
        <v-card outlined width="100%" class="mb-2 py-0">
          <v-col cols="11" class="py-0 my-0" align-self="center">
            <v-row justify="space-between" class="py-2">
              <v-col
                cols="12"
                md="4"
                :class="$vuetify.breakpoint.mdAndDown ? 'pb-0' : ''"
              >
                <v-radio-group
                  v-model="compraEstado"
                  row
                  mandatory
                  dense
                  class="my-1"
                  :hide-details="true"
                >
                  <v-radio
                    id="pendientes"
                    :label="$t('ordenesCompras.pendientes')"
                    value="pendientes"
                    color="secondary"
                    @change="getOrdenesCompras('pendientes')"
                  ></v-radio>
                  <v-radio
                    id="otros"
                    :label="$t('ordenesCompras.cargados')"
                    value="otros"
                    color="secondary"
                    @change="getOrdenesCompras('otros')"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="strBuscar"
                  append-icon="mdi-magnify"
                  outlined
                  clear-icon="mdi-close-circle"
                  clearable
                  :label="
                    inputFilterFocus
                      ? $t('ordenesCompras.filtro')
                      : $t(
                          'ordenesCompras.filtrarPorAseguradoraPatenteSiniestroSucursal'
                        )
                  "
                  :placeholder="
                    $t(
                      'ordenesCompras.filtrarPorAseguradoraPatenteSiniestroSucursal'
                    )
                  "
                  dense
                  hide-details
                  type="text"
                  @blur="inputFilterFocus = false"
                  @focus="inputFilterFocus = true"
                  @input="onChangeBuscar()"
                  @click:clear="clearBuscar"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-card>
        <Loading
          v-if="showLoading"
          :mensaje="$t('ordenesCompras.esperandoResultadoDeLaPeticionEspere')"
        />
      </v-row>
      <v-divider light />
      <div v-if="noHayOrdenesCompras">
        <span>{{ $t('ordenesCompras.noHayDatosParaMostrar') }}</span>
      </div>
      <div v-else>
        <v-row
          v-for="compra in ordenesCompras"
          :key="compra.id"
          align="center"
          no-gutters
        >
          <v-col v-if="showIconNotificacion(compra.id)" cols="auto" lg="1">
            <v-badge dot overlap color="red" offset-x="18">
              <v-icon left dark :color="colorIconBadge">
                mdi-bell-ring
              </v-icon>
            </v-badge>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="6" sm="3" md="2">
                <LabelField
                  label="Fecha Entrega"
                  :value="compra.fecha1_entrega"
                />
              </v-col>
              <v-col cols="6" sm="3" md="2">
                <LabelField label="#" :value="compra.id" />
              </v-col>
              <v-col cols="6" sm="3" md="2">
                <LabelField
                  :label="$t('ordenesCompras.siniestro')"
                  :value="compra.siniestro"
                />
              </v-col>
              <v-col cols="6" sm="3" md="2">
                <LabelField
                  :label="$t('ordenesCompras.patente')"
                  :value="compra.patente"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <LabelField
                  :label="$t('ordenesCompras.sucursal')"
                  :value="compra.sucursal"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <LabelField
                  :label="$t('ordenesCompras.aseguradora')"
                  :value="compra.aseguradora_nombre"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" lg="2">
            <v-btn
              :to="`compra/?id=${compra.id}`"
              color="blue"
              class="hidden-sm-and-down white--text"
            >
              <v-icon left dark>mdi-arrow-right</v-icon>
              {{ $t('ordenesCompras.ver') }}
            </v-btn>
            <v-btn
              :to="`compra/?id=${compra.id}`"
              small
              color="blue"
              class="hidden-md-and-up white--text"
            >
              <v-icon dark>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-divider light class="mt-1" />
          </v-col>
        </v-row>
      </div>
    </v-container>
    <div class="text-center">
      {{ $t('ordenesCompras.totalRegistros') }}
      <b>{{ ordenesCompras.length }}</b>
    </div>
  </div>
</template>
<script>
import Loading from '../Loading.vue'
import LabelField from '~/components/prestador/LabelField.vue'
import serviceOrdenCompra from '~/services/serviceOrdenCompra'
import { getFechaDeString } from '~/services/utils'

const COLOR_ICON_BAGDE = 'cyan'
const COLOR_ALERT_OBSERVACIONES = 'cyan darken-2'

export default {
  name: 'OrdenesCompras',
  components: { Loading, LabelField },
  props: {
    observaciones: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ordenesCompras: [],
      ordenesComprasSinFiltrar: [],
      mostrarDatos: true,
      showLoading: false,
      mensajeError: '',
      showAlertError: false,
      strBuscar: '',
      compraEstado: 'pendientes',
      inputFilterFocus: false
    }
  },
  computed: {
    noHayOrdenesCompras() {
      return this.ordenesCompras.length === 0 && !this.showLoading
    },
    colorIconBadge() {
      return COLOR_ICON_BAGDE
    },
    colorAlertObervaciones() {
      return COLOR_ALERT_OBSERVACIONES
    }
  },
  created() {
    this.getOrdenesCompras(this.compraEstado)
  },
  modules: {
    getFechaDeString
  },
  methods: {
    cerrarShowAlertError() {
      this.mensajeError = ''
      this.showAlertError = false
    },
    getfiltroOC(status) {
      if (status && status === 'pendientes') {
        return [3]
      }
      return [4, 5, 6, 7, 8, 9, 10]
    },
    async getOrdenesCompras(status) {
      this.showLoading = true
      const busqueda = {
        status: this.getfiltroOC(status),
        vmodelo: true
      }
      if (this.strBuscar !== null && this.strBuscar !== '') {
        this.strBuscar = ''
      }
      await serviceOrdenCompra
        .buscar(this.$config.axiosParams, busqueda)
        .then((response) => {
          this.ordenesCompras = Object.keys(response.data).map((c) => {
            return {
              ...response.data[c],
              fecha1_entrega: getFechaDeString(response.data[c].fecha1_entrega)
            }
          })
          this.ordenesComprasSinFiltrar = this.ordenesCompras
          this.showLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push('/login')
          } else {
            this.ordenesCompras = []
            this.showLoading = false
            this.showAlertError = true
            this.mensajeError = `Error al obtener las ordenes de compras. ${error}`
          }
        })
    },
    onChangeBuscar() {
      if (this.strBuscar) {
        this.strBuscar = this.strBuscar.trim()
      }
      if (this.strBuscar === '') {
        this.ordenesCompras = this.ordenesComprasSinFiltrar
      }
      if (this.strBuscar !== null && this.strBuscar !== '') {
        if (this.ordenesCompras.length === 0) {
          this.ordenesCompras = this.ordenesComprasSinFiltrar
        }
        this.ordenesCompras = this.ordenesCompras.filter((c) => {
          const strABuscar = this.strBuscar.toLowerCase()
          return (
            c.patente.toLowerCase().includes(strABuscar) ||
            c.aseguradora.toLowerCase().includes(strABuscar) ||
            c.siniestro.toLowerCase().includes(strABuscar) ||
            c.sucursal.toLowerCase().includes(strABuscar)
          )
        })
      }
    },
    clearBuscar() {
      this.strBuscar = ''
      this.ordenesCompras = this.ordenesComprasSinFiltrar
    },
    showIconNotificacion(idCompra) {
      const busqueda = this.observaciones.find((item) => item.id === idCompra)
      if (busqueda === undefined) {
        return false
      }
      return true
    },
    async descargarOrdenesComprasExcel() {
      const ExcelJS = require('exceljs')
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('OrdenesCompras')

      const headers = [
        'Compañia',
        'Fecha de entrega programada',
        '#',
        'Siniestro',
        'Sucursal',
        'Patente',
        'V Modelo',
        'Fecha Envio',
        'Status'
      ]
      const fields = [
        'aseguradora',
        'fecha1_entrega',
        'id',
        'siniestro',
        'sucursal',
        'patente',
        'vmodelo',
        'fecha_envio',
        'status_nombre'
      ]
      worksheet.addRow(headers)

      const headerRow = worksheet.getRow(1)
      headerRow.font = { bold: true }
      headerRow.alignment = { horizontal: 'center' }

      headers.forEach((header, index) => {
        const column = worksheet.getColumn(index + 1)
        column.width = header.length + 15
      })

      this.ordenesCompras.forEach((ordenCompra) => {
        const rowData = fields.map((field) => ordenCompra[field])
        worksheet.addRow(rowData)
      })

      worksheet.autoFilter = {
        from: { row: 1, column: 1 },
        to: { row: worksheet.rowCount, column: worksheet.columnCount }
      }

      const buffer = await workbook.xlsx.writeBuffer()

      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = 'Registros.xlsx'
      link.click()

      URL.revokeObjectURL(url)
    }
  }
}
</script>
